import { AssetsMoreIcon } from '@bfe/moly-icons';
import { Tooltip, Image } from '@bfe/moly';
import cls from 'classnames';
import { CoinInfo } from '@/types/common';
import { getIconStrategy, type PoolIcon } from './IconStrategies';
import styles from './index.module.less';
import { appPath } from '@web3/base-utils';

interface RowTitleProps {
  chainCode: string;
  baseStakeCoins: CoinInfo[];
  poolName: string;
  icon: string;
  poolType: string;
  poolCode?: string;
  isHot?: number;
  isNew?: number;
  noticeContent?: number;
  containerClass?: string;
  poolIcons?: PoolIcon[];
}

export const RowTitle = ({
  poolCode,
  isHot,
  isNew,
  noticeContent,
  poolName,
  poolType,
  icon,
  baseStakeCoins,
  containerClass,
  chainCode,
  poolIcons,
}: RowTitleProps) => {
  const IconComponent = getIconStrategy({
    poolCode,
    chainCode,
    poolName,
  });

  return (
    <div className={cls(styles.container, containerClass)}>
      <div className="flex flex-items-center">
        <div className={styles.row}>
          <IconComponent
            projectIcon={icon}
            poolIcons={poolIcons}
            baseStakeCoins={baseStakeCoins}
          />
        </div>

        <div className={cls('ml-2', styles.poolNameBg)}>
          <div className={styles.row}>
            <p className={styles.poolNameCol}>{poolName}</p>
            {noticeContent && (
              <div
                className={styles.tooltipWrap}
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <Tooltip
                  title={noticeContent}
                  overlayClassName={styles.tooltipContainer}
                >
                  <span className={styles.tableHead}>
                    <AssetsMoreIcon className={cls(styles.triangle)} />
                  </span>
                </Tooltip>
              </div>
            )}
          </div>
          <p
            className={cls(
              'no-wrap text-ellipsis',
              styles.poolType,
              styles.poolTypeCol
            )}
          >
            {poolType}
          </p>
        </div>
      </div>

      {(isHot || isNew) && (
        <div className={cls('flex', styles.tagBg, styles.tagBgCol)}>
          {isNew && (
            <div className={cls(styles.newTag, styles.colNewTag)}>New</div>
          )}
          {isHot && (
            <Image
              src={`${appPath}/svg/home/hot.svg`}
              className={cls(styles.hotTag)}
              style={{
                height: 18,
                width: 18,
              }}
              alt=""
            />
          )}
        </div>
      )}
    </div>
  );
};
